import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { baseUrl } from "../../../helper/urls";
import { Icon } from "@iconify/react";
import { ToastContainer, toast } from "react-toastify";

const HowToWork = () => {
  const { token } = useSelector((state) => state.auth);
  const [counselorPdf, setCounselorPdf] = useState(null);
  const [studentPdf, setStudentPdf] = useState(null);

  const handleUpload = async (file, type) => {
    if (!file) {
      toast.warning(`Please select a ${type} PDF file.`);
      return;
    }

    const formData = new FormData();
    formData.append("pdf", file);

    const endpoint =
      type === "counselor"
        ? `${baseUrl}/api/policy/counselor/upload/pdf`
        : `${baseUrl}/api/policy/student/upload/pdf`;

    try {
      await axios.post(endpoint, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(
        `${
          type.charAt(0).toUpperCase() + type.slice(1)
        } PDF uploaded successfully!`
      );
    } catch (error) {
      console.error(error);
      toast.error(`Failed to upload ${type} PDF.`);
    }
  };

  return (
    <div className="container py-5">
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="row g-4">
        {/* Counselor Upload */}
        <div className="col-md-6">
          <div className="card shadow border-0 h-100">
            <div className="card-body text-center">
              <Icon
                icon="mdi:file-pdf-box"
                className="text-danger mb-3"
                width={50}
                height={50}
              />
              <h5 className="card-title">Counselor PDF</h5>
              <input
                type="file"
                accept="application/pdf"
                className="form-control my-3"
                onChange={(e) => setCounselorPdf(e.target.files[0])}
              />
              <button
                className="btn w-100 text-white"
                style={{ backgroundColor: "#124178" }}
                onClick={() => handleUpload(counselorPdf, "counselor")}
              >
                <Icon
                  icon="material-symbols:upload-rounded"
                  className="me-2"
                  width={30}
                  height={30}
                />
                Upload Counselor PDF
              </button>

              {/* Counselor PDF Link */}
              <div className="mt-3">
                <a
                  href={`${baseUrl}/public/uploads/howItWork/c_brochure.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  🔗 View Counselor PDF
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Student Upload */}
        <div className="col-md-6">
          <div className="card shadow border-0 h-100">
            <div className="card-body text-center">
              <Icon
                icon="mdi:file-pdf-box"
                className="text-danger mb-3"
                width={50}
                height={50}
              />
              <h5 className="card-title">Student PDF</h5>
              <input
                type="file"
                accept="application/pdf"
                className="form-control my-3"
                onChange={(e) => setStudentPdf(e.target.files[0])}
              />
              <button
                className="btn w-100 text-white"
                style={{ backgroundColor: "#124178" }}
                onClick={() => handleUpload(studentPdf, "student")}
              >
                <Icon
                  icon="material-symbols:upload-rounded"
                  className="me-2"
                  width={30}
                  height={30}
                />
                Upload Student PDF
              </button>

              {/* Student PDF Link */}
              <div className="mt-3">
                <a
                  href={`${baseUrl}/public/uploads/howItWork/s_brochure.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  🔗 View Student PDF
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToWork;

// import React, { useState } from "react";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import { baseUrl } from "../../../helper/urls";
// import { Icon } from "@iconify/react";

// const HowToWork = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [counselorPdf, setCounselorPdf] = useState(null);
//   const [studentPdf, setStudentPdf] = useState(null);

//   const handleUpload = async (file, type) => {
//     if (!file) return alert(`Please select a ${type} PDF file.`);

//     const formData = new FormData();
//     formData.append("pdf", file);

//     const endpoint =
//       type === "counselor"
//         ? `${baseUrl}/api/policy/counselor/upload/pdf`
//         : `${baseUrl}/api/policy/student/upload/pdf`;

//     try {
//       await axios.post(endpoint, formData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       alert(
//         `${
//           type.charAt(0).toUpperCase() + type.slice(1)
//         } PDF uploaded successfully!`
//       );
//     } catch (error) {
//       console.error(error);
//       alert(`Failed to upload ${type} PDF.`);
//     }
//   };

//   return (
//     <div className="container py-5">
//       <div className="row g-4">
//         {/* Counselor Upload */}
//         <div className="col-md-6">
//           <div className="card shadow border-0 h-100">
//             <div className="card-body text-center">
//               <Icon
//                 icon="mdi:file-pdf-box"
//                 className="text-danger mb-3"
//                 width={50}
//                 height={50}
//               />
//               <h5 className="card-title">Counselor PDF</h5>
//               <input
//                 type="file"
//                 accept="application/pdf"
//                 className="form-control my-3"
//                 onChange={(e) => setCounselorPdf(e.target.files[0])}
//               />
//               <button
//                 className="btn w-100 text-white"
//                 style={{ backgroundColor: "#124178" }}
//                 onClick={() => handleUpload(counselorPdf, "counselor")}
//               >
//                 <Icon
//                   icon="material-symbols:upload-rounded"
//                   className="me-2"
//                   width={30}
//                   height={30}
//                 />
//                 Upload Counselor PDF
//               </button>

//               {/* Counselor PDF Link */}
//               <div className="mt-3">
//                 <a
//                   href="https://uat.dreamdor.com/public/uploads/howItWork/c_brochure.pdf"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-decoration-none"
//                 >
//                   🔗 View Counselor PDF
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Student Upload */}
//         <div className="col-md-6">
//           <div className="card shadow border-0 h-100">
//             <div className="card-body text-center">
//               <Icon
//                 icon="mdi:file-pdf-box"
//                 className="text-danger mb-3"
//                 width={50}
//                 height={50}
//               />
//               <h5 className="card-title">Student PDF</h5>
//               <input
//                 type="file"
//                 accept="application/pdf"
//                 className="form-control my-3"
//                 onChange={(e) => setStudentPdf(e.target.files[0])}
//               />
//               <button
//                 className="btn w-100 text-white"
//                 style={{ backgroundColor: "#124178" }}
//                 onClick={() => handleUpload(studentPdf, "student")}
//               >
//                 <Icon
//                   icon="material-symbols:upload-rounded"
//                   className="me-2"
//                   width={30}
//                   height={30}
//                 />
//                 Upload Student PDF
//               </button>

//               {/* Student PDF Link */}
//               <div className="mt-3">
//                 <a
//                   href="https://uat.dreamdor.com/public/uploads/howItWork/s_brochure.pdf"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-decoration-none"
//                 >
//                   🔗 View Student PDF
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HowToWork;

// import React, { useState } from "react";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import { baseUrl } from "../../../helper/urls";
// import { Icon } from "@iconify/react";

// const HowToWork = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [counselorPdf, setCounselorPdf] = useState(null);
//   const [studentPdf, setStudentPdf] = useState(null);

//   const handleUpload = async (file, type) => {
//     if (!file) return alert(`Please select a ${type} PDF file.`);

//     const formData = new FormData();
//     formData.append("pdf", file);

//     const endpoint =
//       type === "counselor"
//         ? `${baseUrl}/api/policy/counselor/upload/pdf`
//         : `${baseUrl}/api/policy/student/upload/pdf`;

//     try {
//       await axios.post(endpoint, formData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       alert(
//         `${
//           type.charAt(0).toUpperCase() + type.slice(1)
//         } PDF uploaded successfully!`
//       );
//     } catch (error) {
//       console.error(error);
//       alert(`Failed to upload ${type} PDF.`);
//     }
//   };

//   return (
//     <div className="container py-5">
//       <div className="row g-4">
//         {/* Counselor Upload */}
//         <div className="col-md-6">
//           <div className="card shadow border-0 h-100">
//             <div className="card-body text-center">
//               <Icon
//                 icon="mdi:file-pdf-box"
//                 className="text-danger mb-3"
//                 width={50}
//                 height={50}
//               />
//               <h5 className="card-title">Counselor PDF</h5>
//               <input
//                 type="file"
//                 accept="application/pdf"
//                 className="form-control my-3"
//                 onChange={(e) => setCounselorPdf(e.target.files[0])}
//               />
//               <button
//                 className="btn btn-primary w-100"
//                 onClick={() => handleUpload(counselorPdf, "counselor")}
//               >
//                 <Icon
//                   icon="material-symbols:upload-rounded"
//                   className="me-2"
//                   width={30}
//                   height={30}
//                 />
//                 Upload Counselor PDF
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Student Upload */}
//         <div className="col-md-6">
//           <div className="card shadow border-0 h-100">
//             <div className="card-body text-center">
//               <Icon
//                 icon="mdi:file-pdf-box"
//                 className="text-danger mb-3"
//                 width={50}
//                 height={50}
//               />
//               <h5 className="card-title">Student PDF</h5>
//               <input
//                 type="file"
//                 accept="application/pdf"
//                 className="form-control my-3"
//                 onChange={(e) => setStudentPdf(e.target.files[0])}
//               />
//               <button
//                 className="btn btn-success w-100"
//                 onClick={() => handleUpload(studentPdf, "student")}
//               >
//                 <Icon
//                   icon="material-symbols:upload-rounded"
//                   className="me-2"
//                   width={30}
//                   height={30}
//                 />
//                 Upload Student PDF
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HowToWork;
